$( document ).ready(function() {
   checkLocation();
    try {
      $('.regCusOneSubmitBtn').click(function(){
      rWorldUserReg();
      });
    
  }
  catch(e) {
    
  }
    
    $("#nvSubButton").on("click",function() {
        careerFormValidation();
    });
  
    $('#bkCountPls').click(function() {
    $('#nvQCountNum').html(function(i, val) { return val*1+1 });
});

$('#bkCountMns').click(function() {
    var Quant = $('#nvQCountNum').html().valueOf()
    $('#nvQCountNum').html(function(i, val) { 
        if(Quant  <= 1){
            $('#nvQCountNum').html("1") 
        }
        else{
        return val*1-1
        }
     });
});
  try{
    var TotCharge = 0;
     var nvUserSubsType = $("#nvUserSubsType input[name='nvradiobtn']:checked").val();
     var userSelectCount= $('#nvQCountNum').html().valueOf();
    
     var deliveryCharge = $("#nvDelChrg").html().valueOf(); 
     var num1 = parseInt(nvUserSubsType,10); 
     var num2 = parseInt(userSelectCount,10); 
     var num3 = parseInt(deliveryCharge,10); 
     TotCharge = num1 * num2  + num3;
    $("#nvTotalChrg").html(TotCharge);
  }
   catch(e) {
    
  }
     
  $(".rekhtanamaInLang input[name='rekhtanamalangbtn']").on("click",function(){
    calculateamt();
  });
  
  
  /*function checkLocation(){
   var nvUserSubsType = $("#nvUserSubsType input[name='nvradiobtn']:checked").val();         
     if(nvUserSubsType==250){
       $("#innerSingle input[name='rekhtanamalangbtn']").removeAttr("disabled");
       $("#innerAnnual input[name='rekhtanamalangbtn']").attr('disabled', true);
       $("#innerAnnual input[name='rekhtanamalangbtn']").attr('checked',false);       
       $("#rr_digitalUrdu").attr('checked',false);     
       $("#rr_digitalHindi").attr('checked',false);      
     
    }else{
         $("#innerAnnual input[name='rekhtanamalangbtn']").removeAttr("disabled");
         $("#innerSingle input[name='rekhtanamalangbtn']").attr('disabled', true);
         $("#innerSingle input[name='rekhtanamalangbtn']").attr('checked',false);      
         $("#rr_digitalUrdu").attr('checked',false);        
         $("#rr_digitalHindi").attr('checked',false);
    }   
    
  }*/
  
 function checkLocation(){
   var nvUserSubsType = $("#nvUserSubsType input[name='nvradiobtn']:checked").val();         
     if(nvUserSubsType==250){
       $("#innerSingle input[name='rekhtanamalangbtn']").removeAttr("disabled");
       $("#innerAnnual input[name='rekhtanamalangbtn']").attr('disabled', true);
       $("#innerAnnual input[name='rekhtanamalangbtn']").attr('checked',false);       
       $("#rr_digitalUrdu").attr('checked',false);     
       $("#rr_digitalHindi").attr('checked',false); 
       $(".rt_secHide, .rt_TotalSticky").removeClass("contMini");       
       $("#innerAnnual").addClass('rr_hideError'); 
       $("#innerSingle").removeClass('rr_hideError');       
     
    }else{
         $("#innerAnnual input[name='rekhtanamalangbtn']").removeAttr("disabled");
         $("#innerSingle input[name='rekhtanamalangbtn']").attr('disabled', true);
         $("#innerSingle input[name='rekhtanamalangbtn']").attr('checked',false);      
         $("#rr_digitalUrdu").attr('checked',false);        
         $("#rr_digitalHindi").attr('checked',false);
         $(".rt_secHide, .rt_TotalSticky").removeClass("contMini");
         $("#innerSingle").addClass('rr_hideError');
          $("#innerAnnual").removeClass('rr_hideError');
    }   
    
  } 
  
  
     /* $('#rr_digitalUrdu').on('click', function() {    
      console.log("urdu");      
          $("#nvUserSubsType input[name='nvradiobtn']").attr('checked',false);       
          $("#rr_digitalHindi").attr('checked',false);
          $("#innerAnnual input[name='rekhtanamalangbtn']").attr('disabled', true);
          $("#innerSingle input[name='rekhtanamalangbtn']").attr('disabled', true);
          $(".rt_secHide, .rt_TotalSticky").addClass("contMini");
       });
    
    $('#rr_digitalHindi').on('click', function() {
    
      console.log("hindi");      
       $("#nvUserSubsType input[name='nvradiobtn']").attr('checked',false);       
       $("#rr_digitalUrdu").attr('checked',false);
       $("#innerAnnual input[name='rekhtanamalangbtn']").attr('disabled', true);
       $("#innerSingle input[name='rekhtanamalangbtn']").attr('disabled', true);
        $(".rt_secHide, .rt_TotalSticky").addClass("contMini");
       });*/
  
  
    
       
  
   
  
  function calculateamt(){   
    checkLocation();
  var TotCharge = 0;
   var nvUserSubsType = $("#nvUserSubsType input[name='nvradiobtn']:checked").val();
      var rekhtanamalangbtn = jQuery(".rekhtanamaInLang input[name='rekhtanamalangbtn']:checked").val();
     var userSelectCount= $('#nvQCountNum').html().valueOf();
    var DelChrg=50;
   /* if(nvUserSubsType==250){
     $("#nvSingle input[name='nvradiobtn']").attr('checked',true);
       $("#nvAnnual input[name='nvradiobtn']").attr('checked',false);
    }else{
      $("#nvSingle input[name='nvradiobtn']").attr('checked',false);
       $("#nvAnnual input[name='nvradiobtn']").attr('checked',true);
    }
    */
    
    if(nvUserSubsType==250 && rekhtanamalangbtn=='bo'){
  	 DelChrg=100;
    }else  if(nvUserSubsType==800 && rekhtanamalangbtn=='bo'){
        DelChrg=400;
    }else  if(nvUserSubsType==250 && rekhtanamalangbtn !='bo'){
       DelChrg=50;
    }else  if(nvUserSubsType==800 && rekhtanamalangbtn !='bo'){
      
      DelChrg=200;
    
    }
    
       $("#nvDelChrg").val(DelChrg);
  	  $("#nvDelChrg").text(DelChrg);
    
     if(userSelectCount > 2){
        
         if(nvUserSubsType == 250){
         
           if(userSelectCount % 3 == 0){
            var delCha = DelChrg * ((userSelectCount / 3)+1);
            $("#nvDelChrg").text(delCha);
           }
           else{
           var numberRemain = ~~(userSelectCount / 3);
             numberRemain = numberRemain + 1;
             var delCha = DelChrg * numberRemain;
            $("#nvDelChrg").text(delCha);
           }
           
         }
         else{
         
           if(userSelectCount % 3 == 0){
           var delCha = DelChrg * ((userSelectCount / 3)+1);
           $("#nvDelChrg").text(delCha);
           }
           else{
           var numberRemain = ~~(userSelectCount / 3);
               numberRemain = numberRemain + 1;
             var delCha = DelChrg * numberRemain;
            $("#nvDelChrg").text(delCha);
           }
           
         }
        
     }else{
      $("#nvDelChrg").text(delCha);
     }
    
    
     var deliveryCharge = $("#nvDelChrg").html().valueOf(); 
     var num1 = parseInt(nvUserSubsType,10); 
     var num2 = parseInt(userSelectCount,10); 
     var num3 = parseInt(deliveryCharge,10); 
       if(rekhtanamalangbtn=='bo'){
       num1=num1*2;
       }
     TotCharge = num1 * num2  + num3;
     if(num2 <= 0){
        TotCharge=0;
     }
    $("#nvTotalChrg").html(TotCharge);
    
    
  }
  
    
    
    $("#nvUserSubsType input[name='nvradiobtn']").on("click",function(){
      
         calculateamt();
      //  var TotCharge = 0;
   //  var nvUserSubsType = $("#nvUserSubsType input[name='nvradiobtn']:checked").val();
   //  var userSelectCount= $('#nvQCountNum').html().valueOf();
    
      
    //   if(userSelectCount > 3){
        
      //   if(nvUserSubsType == 250){
         
        //   if(userSelectCount % 4 == 0){
        //    var delCha = 50 * ((userSelectCount / 4)+1);
        //    $("#nvDelChrg").text(delCha);
         //  }
         //  else{
         //  var numberRemain = ~~(userSelectCount / 4);
        //     numberRemain = numberRemain + 1;
          //   var delCha = 50 * numberRemain;
         //   $("#nvDelChrg").text(delCha);
         //  }
           
        // }
        // else{
         
        //   if(userSelectCount % 4 == 0){
         //  var delCha = 200 * ((userSelectCount / 4));
         //  $("#nvDelChrg").text(delCha);
         //  }
         //  else{
         //  var numberRemain = ~~(userSelectCount / 4);
          //   var delCha = 200 * numberRemain;
         //   $("#nvDelChrg").text(delCha);
         //  }
           
           
        // }
       
        
     // }
    //  else{
    //  $("#nvDelChrg").text('50');
    //  }
    
    // var deliveryCharge = $("#nvDelChrg").html().valueOf(); 
    // var num1 = parseInt(nvUserSubsType,10); 
    // var num2 = parseInt(userSelectCount,10); 
    // var num3 = parseInt(deliveryCharge,10); 
   //  TotCharge = num1 * num2  + num3;
   // $("#nvTotalChrg").html(TotCharge);
    });
    
    
    
    
    
    
    $("#bkCountPls,#bkCountMns").on("click",function(){
         calculateamt();
    //    var TotCharge = 0;
   //  var nvUserSubsType = $("#nvUserSubsType input[name='nvradiobtn']:checked").val();
   // // var userSelectCount= $('#nvQCountNum').html().valueOf();
    
     // if(userSelectCount > 3){
        
        
     //   if(userSelectCount % 4 == 0 && nvUserSubsType == 250){
    //    var delCha = 50 * ((userSelectCount / 4)+1);
    //    $("#nvDelChrg").text(delCha);
    //  }
    //    else if(userSelectCount % 4 == 0 && nvUserSubsType == 800){
     //   var delCha = 200 * ((userSelectCount / 4));
     //   $("#nvDelChrg").text(delCha);
          
     //   }
        
    //  }
    //  else{
   //   $("#nvDelChrg").text('50');
   //   }
      
   //  var deliveryCharge = $("#nvDelChrg").html().valueOf(); 
    // var num1 = parseInt(nvUserSubsType,10); 
   //  var num2 = parseInt(userSelectCount,10); 
   //  var num3 = parseInt(deliveryCharge,10); 

   //  TotCharge = num1 * num2  + num3;
   //  if(num2 <= 0){
   //     TotCharge=0;
   //  }
   // $("#nvTotalChrg").html(TotCharge);
    });
   

jQuery('.formField input ,.nvCountry select').on('keypress', function () {
                jQuery(this).next().slideUp(function () {
                    jQuery('.errorAplrMessage').remove();
                });

            });
            jQuery("#nvUusercountry").on("click", function () {
                jQuery(this).next().slideUp(function () {
                    jQuery('.errorAplrMessage').remove();
                });

            });
  
  jQuery(".rekhtanamaInLang input[name='rekhtanamalangbtn']").on('change',function(){
  
    jQuery('.rekhtanamaInLang .errorAplrMessage').remove();
    
  });
  
  
  
  //For radio button Link 14-september-2021

  /*$("#rt_magLag input[type='radio']").change(function() {
    if(this.checked) {
      // window.location = this.value;  		
        var url = this.value;  
        window.open(url, '_blank');     
            
    }
  
  });*/

  
  
  //For radio button Link 14-september-2021

  /*For Title tag on chat iframe in footer*/
      jQuery('#dummy-chat-button-iframe').prop('title', 'chat-text-box');
     var myTitle = jQuery('#dummy-chat-button-iframe').prop('title');
     console.log(myTitle);
      /*For Title tag on chat iframe in footer*/
  });
  
  function rWorldUserReg(){
  
  alert("hi");
    
  }
  
  
  
 


function paymentrekhtanama(id,totalCharges,order_id,nvUserName,nvUserEmail,contactNo,nvuserAdd,OrderName,OrderNameId){

  $('.rnloader').hide();
  
  var OrderName = OrderName;
  var OrderNameId = OrderNameId;
  var totalPay = totalCharges;
  var id = id;
  
var options = {
    "key": "rzp_live_apJyDn7LJvB8uT", // Enter the Key ID generated from the Dashboard
    "amount": totalCharges, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    "currency": "INR",
    "name": "Rekhta Foundation",
    "description": "Rekhta Rauzan",
    "image": "https://cdn.shopify.com/s/files/1/0355/1415/5141/files/Rbooks.png?v=15367934281979873164",
    "order_id": order_id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
  //"order_id":'order_FrNKOJMKP6LvtK',
  "handler": function (response){
        
       $('.rnloader').show();
      var aPorderId = response.razorpay_order_id;
      var aPPaymentId = response.razorpay_payment_id;
      var aPSignature = response.razorpay_signature;
      
       if(aPSignature && aPPaymentId){
      
        localStorage.setItem("Payment", aPPaymentId);
      
      }
      
      getpaymentDetails(id,aPorderId,aPPaymentId,aPSignature,OrderName,OrderNameId,totalPay);
      
     window.location.href = "https://rekhtabooks.com/pages/payment-success";
      
      
    },
    "prefill": {
        "name": nvUserName,
        "email": nvUserEmail,
        "contact": contactNo
    },
    "notes": {
        "address": nvuserAdd
    },
    "theme": {
        "color": "#e85f42"
    }
};
   var rzp1 = new Razorpay(options);
    rzp1.open();
  
  /*21-september-2021*/
  
 /*if($('#rr_digitalUrdu').is(':checked'))
  {
    window.location.href = 'https://www.magzter.com/IN/Rekhta-Foundation/Rekhta-Rauzan---Urdu/Culture/?redirect=true';    
    
  }
  
  else if($('#rr_digitalHindi').is(':checked'))
  {
    window.location.href = 'https://www.magzter.com/IN/Rekhta-Foundation/Rekhta-Rauzan---Hindi/Culture/';    
  }
  else
  {
    var rzp1 = new Razorpay(options);
    rzp1.open();
  }*/

}

function getpaymentDetails(id,aPorderId,aPPaymentId,aPSignature,OrderName,OrderNameId,totalPay){

 jQuery.post(
      "https://world.rekhta.org/api/ApiPayment/RekhtanamaPaymentStatus", {
        orderId: aPorderId,
        Id: id,
        TotalPay: totalPay,
        razorpay_payment_id: aPPaymentId,
        razorpay_signature: aPSignature,
        OrderName: OrderName,
        OrderNameId: OrderNameId
        },
      function (data) {
        
               //alert(data.captured);
       
       localStorage.setItem("PaymentMethod", data.method);
        if(data.captured){
        //alert("Payment successful");
        }
        else{
        //alert("Payment Error");
        }
        
        
      }
    )

}

function careerFormValidation() {
 var nvUserName = jQuery('#nvUserName').val().trim();
 var nvuserCont = jQuery('#nvUserCont').val().trim();
 var nvUserEmail = jQuery('#nvUserEmail').val().trim();
 var nvuserAdd = jQuery('#nvuserAdd').val().trim();
 var nvuserCity = jQuery('#nvUserCity').val().trim();
 var nvUuserstate = jQuery('#nvUuserstate').val().trim();
 var nvUserPinCode = jQuery('#nvUserPinCode').val().trim();
 var rekhtanamainlang = jQuery("input[name='rekhtanamalangbtn']:checked").val();
  //17-jan-2022
  var pattern = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/  
  //17-jan-2022 

if (nvUserName.length == 0) {
   jQuery('#nvUserName').addClass('errorAplrField');
   if (jQuery('.errorAplrMessage').length <= 0) {
           jQuery("<span class='errorAplrMessage'>* Name can't be blank!</span>").insertAfter('#nvUserName').slideDown();
     window.scrollTo(0, jQuery("#nvUserName").offset().top - 100);
       }
  
       return false;
   }
   if (nvuserCont.length == 0) {
   jQuery('#nvUserCont').addClass('errorAplrField');
   if (jQuery('.errorAplrMessage').length <= 0) {
           jQuery("<span class='errorAplrMessage'>* Contact Number can't be blank!</span>").insertAfter('#nvUserCont').slideDown();
     window.scrollTo(0, jQuery("#nvUserCont").offset().top - 100);
       }
       return false;
   }
   else if (nvuserCont.length < 10 || nvuserCont.length > 15) {
            jQuery('#nvUserCont').addClass('errorAplrField');
            if (jQuery('.errorAplrMessage').length <= 0) {

                    jQuery("<span class='errorAplrMessage'>* Invalid Mobile Number!</span>").insertAfter('#nvUserCont').slideDown();
               window.scrollTo(0, jQuery("#nvUserCont").offset().top - 100);
                }
              
                 
            return false;
        }
   
  

if (nvUserEmail.length == 0) {
   jQuery('#nvUserEmail').addClass('errorAplrField'); 
   if (jQuery('.errorAplrMessage').length <= 0) {
           jQuery("<span class='errorAplrMessage'>* Email can't be blank!</span>").insertAfter('#nvUserEmail').slideDown();
      window.scrollTo(0, jQuery("#nvUserEmail").offset().top - 100);
       }
       return false;
}
 
  /*17-jan-2022*/
  if (nvUserEmail.match(pattern)) {   
    console.log("Your Email Address in valid");  
  } else {   
    jQuery('<span class="errorAplrMessage">* Enter Valid Email Address</span>').insertAfter('#nvUserEmail').slideDown();
    window.scrollTo(0, jQuery("#nvUserEmail").offset().top - 100); 
     
  }  
  /*17-jan-2022*/  
  
 if (!validateEmail1(nvUserEmail)) {
       jQuery('#nvUserEmail').addClass('errorBorder');
       if (jQuery('.errorAplrMessage').length <= 0) {
               jQuery('<span class="errorAplrMessage">* Invalid Email!</span>').insertAfter('#nvUserEmail').slideDown();
         window.scrollTo(0, jQuery("#nvUserEmail").offset().top - 100);
           }
           return false;
          
       }
  
  
  

  if (nvuserAdd.length == 0) {
   jQuery('#nvuserAdd').addClass('errorAplrField');
   if (jQuery('.errorAplrMessage').length <= 0) {
           jQuery("<span class='errorAplrMessage'>* Address can't be blank!</span>").insertAfter('#nvuserAdd').slideDown();
     window.scrollTo(0, jQuery("#nvuserAdd").offset().top - 100);
       }
       return false;
   }
   if (nvuserCity.length == 0) {
   jQuery('#nvUserCity').addClass('errorAplrField');
   if (jQuery('.errorAplrMessage').length <= 0) {
           jQuery("<span class='errorAplrMessage'>* City can't be blank!</span>").insertAfter('#nvUserCity').slideDown();
     window.scrollTo(0, jQuery("#nvUserCity").offset().top - 100);
       }
       return false;
   }
   if (nvUuserstate.length == 0) {
   jQuery('#nvUuserstate').addClass('errorAplrField');
   if (jQuery('.errorAplrMessage').length <= 0) {
           jQuery('<span class="errorAplrMessage">* Please Select state!</span>').insertAfter('#nvUuserstate').slideDown();
     window.scrollTo(0, jQuery("#nvUuserstate").offset().top - 100);
       }
       return false;
   }
   if (nvUserPinCode.length == 0) {
   jQuery('#nvUserPinCode').addClass('errorAplrField');
   if (jQuery('.errorAplrMessage').length <= 0) {
           jQuery("<span class='errorAplrMessage'>* Pin Code can't be blank!</span>").insertAfter('#nvUserPinCode').slideDown();
     window.scrollTo(0, jQuery("#nvUserPinCode").offset().top - 100);
       }
       return false;
   }
   else if (nvUserPinCode.length < 5 || nvUserPinCode.length > 6) {
            jQuery('#nvUserPinCode').addClass('errorAplrField');
            if (jQuery('.errorAplrMessage').length <= 0) {

                    jQuery('<span class="errorAplrMessage">* Invalid Pin Code!</span>').insertAfter('#nvUserPinCode').slideDown();
              window.scrollTo(0, jQuery("#nvUserPinCode").offset().top - 100);
                }
              
                 
            return false;
        }
  
if((rekhtanamainlang == undefined || rekhtanamainlang == ' ')) {  
  jQuery('.rekhtanamaInLang').append('<span class="errorAplrMessage">* Please select Rekhtanama Edition!</span>');
    window.scrollTo(0, jQuery(".rekhtanamaInLang").offset().top - 100);
    return false;
  }

  
   /* if((rekhtanamainlang == undefined || rekhtanamainlang == ' ') && $('#nvUserSubsType input[name=nvradiobtn]').is(':checked') == true){
  
  jQuery('.rekhtanamaInLang').append('<span class="errorAplrMessage">* Please select Rekhtanama Edition!</span>');
    window.scrollTo(0, jQuery(".rekhtanamaInLang").offset().top - 100);
    return false;
  }*/
 
  bookOrderAPi();
  
  
  
}
function validateEmail1(sEmail) {
    var filter = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (filter.test(sEmail)) {
        return true;
    } else {
        return false;
    }
}


function bookOrderAPi(){
  
  $('.rnloader').show();
  
  
  localStorage.removeItem("Name");
  localStorage.removeItem("Email");
  localStorage.removeItem("Address");
  localStorage.removeItem("City");
  localStorage.removeItem("Country");
  localStorage.removeItem("Pin");
  localStorage.removeItem("Phone");
  localStorage.removeItem("Quantity");
  localStorage.removeItem("Price");
  localStorage.removeItem("SubTotal");
  localStorage.removeItem("DeliveryCharges");
  localStorage.removeItem("TotalCharges");
  localStorage.removeItem("RekhtanamaEdition");
  localStorage.removeItem("Substype");
  localStorage.removeItem("PaymentMethod");
  localStorage.removeItem("Payment");
  localStorage.removeItem("Order");

 var nvUserName = jQuery('#nvUserName').val().trim();
 var nvuserContCode = '+'+jQuery('.iti__active').attr('data-dial-code');
 var nvuserCont = jQuery('#nvUserCont').val().trim();
  var contactNo = '+91' + ''+nvuserCont;
 var nvUserEmail = jQuery('#nvUserEmail').val().trim();
 var nvuserAdd = jQuery('#nvuserAdd').val().trim();
 var nvuserCity = jQuery('#nvUserCity').val().trim();
 var nvUuserstate = jQuery('#nvUuserstate').val().trim();
 var nvUserPinCode = jQuery('#nvUserPinCode').val().trim();

 var subcriptionTypeVal = jQuery("input[name='nvradiobtn']:checked").val();
     var rekhtanamalangbtn = jQuery(".rekhtanamaInLang input[name='rekhtanamalangbtn']:checked").val();
  var subcriptionType = 1;
  var price = 0;
  if(subcriptionTypeVal == 250){
    subcriptionType = 1;
    price = subcriptionTypeVal;
  }
  else{
    subcriptionType = 2;
    price = subcriptionTypeVal;
  }
  if(rekhtanamalangbtn=='bo'){
  price=price*2;
  }
  
  var sLType = '';
  if(subcriptionType == 2){
  sLType = 'Annual';
  }
  else{
  sLType = 'Single';
  }
  
  var rekhtanamaEdition = jQuery("input[name='rekhtanamalangbtn']:checked").val();
  
  var quantity = jQuery('#nvQCountNum').text();
  var deliveryCharges = jQuery('#nvDelChrg').text();
  var totalCharges = jQuery('#nvTotalChrg').text();
  
  var OrderName = 'Rekhtanama';
  var OrderNameId = '9e0c28c0-dfa9-4924-8034-6646a87eb2a3';
  var Discount = 0;
  
  var subTotal = quantity * price;
  
  localStorage.setItem("Name", nvUserName);
  localStorage.setItem("Email", nvUserEmail);
  localStorage.setItem("Address", nvuserAdd);
  localStorage.setItem("City", nvuserCity);
  localStorage.setItem("Country", nvUuserstate);
  localStorage.setItem("Pin", nvUserPinCode);
  localStorage.setItem("Phone", nvuserCont);
  localStorage.setItem("Quantity", quantity);
  localStorage.setItem("Price", subcriptionTypeVal);
  localStorage.setItem("SubTotal", subTotal);
  localStorage.setItem("DeliveryCharges", deliveryCharges);
  localStorage.setItem("TotalCharges", totalCharges);
  localStorage.setItem("RekhtanamaEdition", rekhtanamaEdition);
  localStorage.setItem("Substype", sLType);
  localStorage.setItem("PaymentMethod",' ');
  localStorage.setItem("Payment",' ');
  
  /*if($('#rr_digitalUrdu').is(':checked')) 
  {
    rekhtanamaEdition = "Di-Ur";    
    
  }
  
  else if($('#rr_digitalHindi').is(':checked'))    
  {
    rekhtanamaEdition = "Di-Hi"; 
  }*/
  
  
  jQuery.post(
      "https://world.rekhta.org/api/ApiPayment/CreateRekhtanamaOrder", {
        OrderName: OrderName,
        OrderNameId: OrderNameId,
        Quantity: quantity,
        Price: price,
        Delivery_Charges: deliveryCharges,
        PaymentMode: '',
        UserName: nvUserName,
        PhoneNo: contactNo,
        EmailId: nvUserEmail,
        UserAddress: nvuserAdd,
        City: nvuserCity,
        Country: nvUuserstate,
        ZipCode: nvUserPinCode,
        SubscriptionType: subcriptionType,
        BookLang : rekhtanamaEdition,
        Discount: Discount,
        TotalPay: totalCharges
        },
      function (data) {
        
        var id = data.Id;
        var order_id = data.orderId;
        
        if(order_id){
        localStorage.setItem("Order", order_id);
        }
        
        paymentrekhtanama(id,totalCharges,order_id,nvUserName,nvUserEmail,contactNo,nvuserAdd,OrderName,OrderNameId);
        
      }
    )
  .fail(function () {
     $('.rnloader').hide();
    
    var errorMsg = '<p class="rnServerError">Server error! Please try again.</p>';
    $('.nvFormContainer').append(errorMsg);
    window.scrollTo(0, jQuery(".nvFormContainer").offset().top - 120);
    
    });        
        
        
        
  
  
}



 $(document).ready(function () {	 
    if(window.location.href.includes('ref=rev')) {      
      //$('html, body').animate({scrollTop:0}, 'slow') - 120px;
      $('html, body').animate({scrollTop: $('#shopify-section-gl-product-page-description').offset().top -100 }, '5000');
    }
	
   /*06-December-2021 for input redirect another url*/
    $(".addPDFLink input").change(function() {
    if(this.checked) {
      // window.location = this.value;  		
        var url = this.value;  
        window.open(url, '_blank');
    }
      });
}); 

/*
function emailValidate() {  
  var  eml = document.getElementById('nvUserEmail').value
  var pattern = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/
  if (eml.match(pattern)) {   
    console.log("Your Email Address in valid");  
  } else {   
   $('<span class="errorAplrMessage">* Enter Valid Email Address</span>').insertAfter('#nvUserEmail').slideDown();
       window.scrollTo(0, jQuery("#nvUserEmail").offset().top - 100); 
  }  
}*/

/*18-July-2022 Rekhta Rauzen*/

$(".navBannerSection img").click(function() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".navContentSection").offset().top -110
    }, 2000);
});
/*18-July-2022 Rekhta Rauzen*/
/*For Blog Page 26-Sep-2022*/
/*For Search double*/
$(function() {
    var head = $("header");
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
    
        if (scroll >= 10) {
            head.removeClass('clearHeader').addClass("darkHeader");
        } else {
            head.removeClass("darkHeader").addClass('clearHeader');
        }
    });
});
$(".rb_blogDesignNew:first-child article").append("<h3>Recent Blogs</h3>");

/*For Blog Page 26-Sep-2022*/

/*07-October-2022*/
$(document).ready(function(){
 currLoc = $(location).attr('href');
 if(currLoc == "https://rekhtabooks.com/products/tafseer-ul-quran-2?_pos=1&_sid=2ee55ab86&_ss=r")
 {
   window.location.href = "https://rekhtabooks.com/products/tafseer-ul-quran-volume-004?_pos=4&_sid=2ee55ab86&_ss=r";
 }
  else if(currLoc == "https://rekhtabooks.com/products/the-essential-dictionary-of-urdu-shaayari")
  {   
   window.location.href = "https://rekhtabooks.com/products/the-dictionary-of-urdu-poetry"; 
  }
  else if(currLoc == "https://rekhtabooks.com/products/urdu-learning-box")
  {   
   window.location.href = "https://rekhtabooks.com/products/urdu-learning-set"; 
  }
});
/*07-October-2022*/

/*24-January-2023 for Text message switch on header top */
/*$(document).ready(function(){   
var textArray = ["<p><strong>EXTRA 10% OFF</strong> on 1st order. Code: <strong>FIRSTORDER, | FREE SHIPPING</strong> on All Orders (Over Rs 349)</p>","<p>Get upto <strong>40% OFF</strong> | Code: <strong>REPUBLICDAY </strong></p>"];
  var index = 0;
  setInterval(function(){        
  $("#changeText").animate({
    //opacity:0
    },function()
    {
       if(textArray.length > index) {
       $(this).html(textArray[index]).animate({opacity:1})
       index++; 
       }
       else
       index = 0;
    });
  },10000);
});
*/

/*24-January-2023 for Text message switch on header top */


/*07-April-2023 For Author filter link */ 
    $(".rb_fromadmin").click(function(){     
       var href = $(this).prop('href');  
       var result = href.split(',').join('');
    
       var newUrl = result.split("%20").join("-");
       window.location.replace(newUrl);
    });
/*07-April-2023 For Author filter link */

/*14-June-2023 For Dummy button*/

$(document).ready(function() {
   $("#buyrbNew").click(function(){
    $("magic-checkout-btn").click(); 
    return false;
  });

  /*For Read More Sample Data
 
    var text = $("#readsample_tab").text();
    var convertedString = String(text);
    var matchIndex = convertedString.indexOf("Read Sample Data");
    var resultBefore = convertedString.substring(0, matchIndex); 
    //document.getElementById("tab-description").innerHTML = resultBefore; 
     $('#tab-description').html(resultBefore).css({"white-space":"pre-line", "font-size":"16px", "line-height":"30px"});
    var resultAfter = convertedString.substring(matchIndex);
    //console.log(document.getElementById("readsample_tab"));
    $('#readsample_tab').html(resultAfter).css({"white-space":"pre-line", "font-size":"16px", "line-height":"30px"});
    //document.getElementById("readsample_tab").innerHTML = resultAfter;*/
 
  
});


/*14-June-2023 For Dummy button*/


$(document).ready(function(){
 currLoc = $(location).attr('href');
 if(currLoc == "https://rekhtabooks.com/products/hazaaron-khwahishen-gift-box")
 {  
   console.log("kfkfk");
  $(".popupShown").css("display", "none");
 }
 
});